export default __webpack_public_path__ + "images/ee4322f567573ff493678b674da2e163-thanksgiving.webp";